<div class="lrs-page" [class.embedded]="embedded" [class.integrated]="integratedMode" [class.sidebar-panel-only]="sidebarPanelOnly">
  <header class="lrs-header" *ngIf="!embedded && !integratedMode && !sidebarPanelOnly">
    <div>
      <h1>LRS Asset Lifecycle Management</h1>
      <p class="subtitle">
        Route + measure — dynamic segmentation · NHAI RAMS model
        <span *ngIf="selectedRoute"> · {{ selectedRoute.route_code }}</span>
      </p>
    </div>
    <div class="header-actions">
      <a routerLink="/home/document-list" class="link-btn">Documents</a>
      <button type="button" class="link-btn" (click)="openInGisMvp()">GIS Editor</button>
      <span class="status" *ngIf="statusMessage">{{ statusMessage }}</span>
    </div>
  </header>

  <div class="lrs-embedded-bar" *ngIf="embedded && !integratedMode && !sidebarPanelOnly">
    <div class="lrs-embedded-route" *ngIf="selectedRoute">
      <strong>{{ selectedRoute.route_code }}</strong>
      <span>{{ selectedRoute.route_name }}</span>
    </div>
    <div class="header-actions">
      <a routerLink="/home/document-list" class="link-btn">Documents</a>
      <span class="status" *ngIf="statusMessage">{{ statusMessage }}</span>
    </div>
  </div>

  <div class="lrs-layout" [class.integrated]="integratedMode || sidebarPanelOnly">
    <aside class="lrs-panel">
      <section class="map-tools">
        <h2 *ngIf="!integratedMode">Map</h2>
        <h2 *ngIf="integratedMode && !sidebarPanelOnly">LRS on map</h2>
        <ng-container *ngIf="!integratedMode">
        <label>Basemap</label>
        <select [(ngModel)]="baseMapKey" (ngModelChange)="changeBaseMap($event)">
          <option value="osm">OpenStreetMap</option>
          <option value="googleSatellite">Google Satellite</option>
          <option value="googleHybrid">Google Hybrid</option>
        </select>
        </ng-container>
        <details class="locate-map-block" *ngIf="sidebarPanelOnly">
          <summary>Locate &amp; map</summary>
          <label class="check-row">
            <input type="checkbox" [(ngModel)]="showGeoserverWms" (ngModelChange)="onGeoserverToggle($event)" />
            GeoServer WMS
          </label>
          <button type="button" class="btn secondary" (click)="loadWfsEvents()">Load WFS events</button>
          <label class="check-row">
            <input type="checkbox" [(ngModel)]="clusterEnabled" (ngModelChange)="onClusterSettingsChange()" />
            Cluster point assets
          </label>
          <label class="check-row">
            <input type="checkbox" [ngModel]="mvtMode" (ngModelChange)="toggleMvtLayer()" />
            MVT vector tiles
          </label>
          <button type="button" class="btn secondary" (click)="runRouteQc()" [disabled]="!selectedRouteId">
            LRS QC check
          </button>
          <button type="button" class="btn secondary" (click)="runNetworkQc()">
            Network topology QC
          </button>
          <button type="button" class="btn secondary" (click)="runCalibrationAccuracy()" [disabled]="!selectedRouteId" title="Also included in LRS QC check">
            Calibration only
          </button>
        </details>
        <ng-container *ngIf="!sidebarPanelOnly">
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="showGeoserverWms" (ngModelChange)="onGeoserverToggle($event)" />
          GeoServer WMS
        </label>
        <button type="button" class="btn secondary" (click)="loadWfsEvents()">Load WFS events</button>
        <button type="button" class="btn secondary" (click)="runRouteQc()" [disabled]="!selectedRouteId">
          LRS QC check
        </button>
        <button type="button" class="btn secondary" (click)="runNetworkQc()">
          Network topology QC
        </button>
        <button type="button" class="btn secondary" (click)="runCalibrationAccuracy()" [disabled]="!selectedRouteId" title="Also included in LRS QC check">
          Calibration only
        </button>
        </ng-container>
        <ng-container *ngIf="!sidebarPanelOnly">
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="clusterEnabled" (ngModelChange)="onClusterSettingsChange()" />
          Cluster point assets
        </label>
        <label *ngIf="clusterEnabled">Cluster distance (px)
          <input
            type="range"
            min="20"
            max="80"
            step="5"
            [(ngModel)]="clusterDistancePx"
            (ngModelChange)="onClusterSettingsChange()"
          />
          {{ clusterDistancePx }}px
        </label>
        <p class="hint symbology-hint">
          Clustering and MVT shift symbols for scale (TC-14). Use
          <strong>True position</strong> for survey-accurate coordinates.
        </p>
        <button type="button" class="btn secondary" (click)="enableTruePositionMode()" [class.active]="truePositionMode">
          True position (no clustering)
        </button>
        <p class="hint" *ngIf="truePositionMode">True position on — each symbol is at its stored coordinate.</p>

        <label class="check-row">
          <input type="checkbox" [ngModel]="serverClusterMode" (ngModelChange)="toggleServerCluster()" />
          Server clustering (PostGIS)
        </label>
        <label *ngIf="serverClusterMode">
          Method
          <select [ngModel]="serverClusterMethod" (ngModelChange)="setClusterMethod($event)">
            <option value="dbscan">DBSCAN (density)</option>
            <option value="grid">Grid bins</option>
            <option value="heatmap">Heatmap</option>
            <option value="utility_network">Utility network (hierarchical)</option>
          </select>
        </label>
        <p class="hint" *ngIf="serverClusterMode && serverClusterMeta">
          <ng-container *ngIf="serverClusterMeta.cluster_count != null">{{ serverClusterMeta.cluster_count }} clusters · {{ serverClusterMeta.singleton_count }} single · </ng-container>
          <ng-container *ngIf="serverClusterMeta.total_groups != null">{{ serverClusterMeta.total_groups }} groups</ng-container>
          <ng-container *ngIf="serverClusterMeta.eps_m != null"> · eps {{ serverClusterMeta.eps_m }}m</ng-container>
          <ng-container *ngIf="serverClusterMeta.cell_m != null"> · cell {{ serverClusterMeta.cell_m }}m</ng-container>
        </p>
        <label class="check-row">
          <input type="checkbox" [ngModel]="mvtMode" (ngModelChange)="toggleMvtLayer()" />
          MVT vector tiles (server-streamed)
        </label>
        <p class="hint">Server clustering &amp; vector tiles scale to millions of assets. They are display aggregations, not true positions.</p>
        </ng-container>
      </section>

      <section *ngIf="qcReport" class="qc-block" [class.qc-ok]="qcReport.ok" [class.qc-fail]="!qcReport.ok">
        <h3>QC {{ qcReport.ok ? 'OK' : 'Issues' }}</h3>
        <p class="hint" *ngIf="qcReport.stale_geometry_count">Stale geometries: {{ qcReport.stale_geometry_count }}</p>
        <ul class="qc-list">
          <li *ngFor="let i of qcReport.issues" [class]="'sev-' + i.severity">
            {{ i.message }}
            <small *ngIf="i.repair"> · {{ i.repair.action }}: {{ i.repair.summary }}</small>
          </li>
        </ul>
      </section>

      <section *ngIf="networkQcReport" class="qc-block" [class.qc-ok]="networkQcReport.ok" [class.qc-fail]="!networkQcReport.ok">
        <h3>Network QC {{ networkQcReport.ok ? 'OK' : 'Issues' }}</h3>
        <p class="hint">
          {{ networkQcReport.route_count }} routes · snap ≤ {{ networkQcReport.snap_tolerance_m }} m ·
          {{ networkQcReport.issue_count }} issue(s)
        </p>
        <ul class="qc-list">
          <li *ngFor="let i of networkQcReport.issues" [class]="'sev-' + i.severity">{{ i.message }}</li>
        </ul>
        <p class="hint" *ngIf="networkQcReport.repairs?.length"><strong>Repair suggestions</strong></p>
        <ul class="mini-list" *ngIf="networkQcReport.repairs?.length">
          <li *ngFor="let r of networkQcReport.repairs">
            {{ r.action }} · {{ r.code_a }} ↔ {{ r.code_b }} — {{ r.summary }}
          </li>
        </ul>
      </section>

      <section *ngIf="calibrationReport" class="qc-block" [class.qc-ok]="calibrationReport.ok" [class.qc-fail]="!calibrationReport.ok">
        <h3>Calibration {{ calibrationReport.ok ? 'OK' : 'Review' }}</h3>
        <p class="hint">
          {{ calibrationReport.anchor_count }} anchors ·
          accuracy {{ calibrationReport.accuracy_pct ?? '—' }}% (target ≥{{ calibrationReport.target_pct }}%) ·
          max drift {{ calibrationReport.max_drift_m ?? '—' }} m
          <ng-container *ngIf="calibrationReport.max_error_m_per_km != null">
            · {{ calibrationReport.max_error_m_per_km }} m/km (limit ±1)
          </ng-container>
        </p>
        <ul class="qc-list" *ngIf="calibrationReport.anchors?.length">
          <li *ngFor="let a of calibrationReport.anchors">
            {{ a.label }} &#64; {{ a.measure_km }} km — drift {{ a.drift_m }} m
          </li>
        </ul>
        <p class="hint" *ngIf="calibrationReport.message">{{ calibrationReport.message }}</p>
      </section>

      <section class="import-block network-first">
        <h2>1. Road network</h2>
        <p class="hint">Create the road network and sub-network first. Routes, LRS, and assets stay locked until then.</p>
        <label>Network
          <select [ngModel]="selectedNetworkId" (ngModelChange)="selectNetwork($event)">
            <option [ngValue]="null">Select network</option>
            <option *ngFor="let n of networks" [ngValue]="n.id">{{ n.network_code }} — {{ n.network_name }}</option>
          </select>
        </label>
        <label>Code <input [(ngModel)]="newNetworkCode" placeholder="NET-01" /></label>
        <label>Name <input [(ngModel)]="newNetworkName" placeholder="Project road network" /></label>
        <button type="button" class="btn" (click)="createNetwork()">Create network</button>
        <label>Sub-network
          <select [(ngModel)]="selectedSubnetworkId">
            <option [ngValue]="null">Select sub-network</option>
            <option *ngFor="let s of subnetworks" [ngValue]="s.id">{{ s.subnetwork_code }} — {{ s.subnetwork_name }}</option>
          </select>
        </label>
        <label>Sub code <input [(ngModel)]="newSubnetworkCode" placeholder="MAIN" /></label>
        <label>Sub name <input [(ngModel)]="newSubnetworkName" placeholder="Main corridor" /></label>
        <button type="button" class="btn" (click)="createSubnetwork()" [disabled]="!hasNetwork">Create sub-network</button>
      </section>

      <section class="gate-stepper" *ngIf="selectedRoute">
        <h2>Validation</h2>
        <ol class="gate-steps">
          <li [class.ok]="selectedRoute.map_ok" [class.fail]="selectedRoute.map_ok === false">
            <strong>Map</strong>
            <span>{{ selectedRoute.map_ok ? 'OSM / basemap accepted' : 'Confirm map matches this corridor' }}</span>
          </li>
          <li [class.ok]="selectedRoute.road_ok" [class.fail]="!selectedRoute.road_ok">
            <strong>Road</strong>
            <span>{{ selectedRoute.road_ok ? 'Clean continuous geometry' : 'Fix gaps / overlaps before LRS' }}</span>
          </li>
          <li [class.ok]="selectedRoute.lrs_ok" [class.fail]="!selectedRoute.lrs_ok">
            <strong>LRS</strong>
            <span>{{ selectedRoute.lrs_ok ? 'Measures accepted — assets unlocked' : 'Calibrate and pass LRS QC' }}</span>
          </li>
        </ol>
        <p class="hint" *ngIf="selectedRoute.length_m">Length from geometry: {{ (selectedRoute.length_m / 1000).toFixed(3) }} km</p>
        <button type="button" class="btn secondary" (click)="confirmMapMatch()" [disabled]="!selectedRouteId || selectedRoute.map_ok">
          Confirm map matches corridor
        </button>
        <button type="button" class="btn secondary" (click)="runRouteQc()" [disabled]="!selectedRouteId">Run Map → Road → LRS QC</button>
        <button type="button" class="btn" (click)="applyNetworkRepairs()" [disabled]="applyingRepairs || !networkQcReport?.repairs?.length">
          {{ applyingRepairs ? 'Applying…' : 'Apply snap / gap repairs' }}
        </button>
      </section>

      <section>
        <h2>Routes</h2>
        <p class="hint" *ngIf="loading">Loading…</p>
        <p class="error" *ngIf="mapError">{{ mapError }}</p>
        <ul class="route-list" *ngIf="routes.length">
          <li
            *ngFor="let r of routes"
            [class.active]="r.id === selectedRouteId"
            (click)="selectRoute(r.id)"
          >
            <strong>{{ r.route_code }}</strong>
            <span>{{ r.route_name }}</span>
            <small>{{ (r.length_m / 1000).toFixed(2) }} km · {{ r.event_count || 0 }} events</small>
          </li>
        </ul>
        <p class="hint" *ngIf="!loading && !routes.length">
          Create the road network first. Routes stay locked until then — then import OSM or draw.
        </p>
        <p class="hint lrs-tab-hint" *ngIf="integratedMode && mapInteractActive">
          Map clicks apply when this LRS tab is active. Use “Set from/to on map” for chainage picks.
        </p>
        <button
          type="button"
          class="btn primary demo-seed-btn"
          (click)="loadDemoShowcase()"
          [disabled]="loading || seedingDemo"
        >
          {{ seedingDemo ? 'Loading demo…' : '▶ One-click LRS demo' }}
        </button>
        <p class="hint">Seeds a demo network + NH-DEMO-48, then stops at Map → Road → LRS validation. Length comes from geometry.</p>
        <p class="hint" *ngIf="demoSeedSummary">
          Demo {{ demoSeedSummary.route_code }} · {{ demoSeedSummary.length_km | number: '1.2-2' }} km ·
          {{ demoSeedSummary.total_events }} assets · UG / OG / XO · PCI · clash
        </p>
      </section>

      <section class="import-block">
        <h3>Import OSM (map extent)</h3>
        <label>Highway ref <input [(ngModel)]="osmRouteRef" placeholder="NH 16" /></label>
        <label>Route code <input [(ngModel)]="newRouteCode" placeholder="NH-16" /></label>
        <button type="button" class="btn" (click)="importOsmFromMapExtent()" [disabled]="!hasNetwork">Import from OSM</button>
      </section>

      <section class="import-block">
        <h3>Import shapefile</h3>
        <p class="hint">ZIP with .shp/.shx/.dbf (centerline → route; points → events). No GDAL required.</p>
        <input type="file" accept=".zip,.shp" (change)="onShapefileSelected($event)" [disabled]="shapefileImporting || !hasNetwork" />
      </section>

      <section class="import-block">
        <h3>Import road_project</h3>
        <label>Project ID <input [(ngModel)]="roadProjectImportId" /></label>
        <button type="button" class="btn" (click)="importRoadProject()" [disabled]="!hasNetwork">Merge sections → route</button>
      </section>

      <section class="import-block">
        <h3>Draw route (centerline)</h3>
        <label>Route name <input [(ngModel)]="newRouteName" placeholder="NH-48 Corridor" /></label>
        <h4>Design attributes (IRC:73)</h4>
        <label>Design speed (km/h)
          <select [(ngModel)]="newRouteDesignSpeed">
            <option [ngValue]="null">—</option>
            <option *ngFor="let s of designSpeeds" [ngValue]="s">{{ s }}</option>
          </select>
        </label>
        <label>Terrain
          <select [(ngModel)]="newRouteTerrain">
            <option value="">—</option>
            <option *ngFor="let t of terrainTypes" [value]="t.id">{{ t.label }}</option>
          </select>
        </label>
        <label>ROW width (m) <input type="number" step="0.5" min="0" [(ngModel)]="newRouteRowWidth" /></label>
        <label>Carriageway
          <select [(ngModel)]="newRouteCarriageway">
            <option value="">—</option>
            <option *ngFor="let c of carriagewayConfigs" [value]="c">{{ c }}</option>
          </select>
        </label>
        <button type="button" class="btn" [class.active]="drawMode" (click)="toggleDrawRoute()" [disabled]="!hasNetwork">
          {{ drawMode ? 'Drawing…' : 'Draw alignment' }}
        </button>
        <p class="hint">Rubber-band snaps to OSM / existing lines at the current zoom. Double-click to finish. Geometry must be clean and continuous.</p>
      </section>

      <section *ngIf="selectedRoute" class="chainage-block">
        <h2>Chainage locate</h2>
        <p class="hint">Click the route to set chainage and open matching BOQ line items.</p>

        <label class="block-label">Reference</label>
        <input class="wide" [(ngModel)]="referenceInput" placeholder="NH-16 &#64; km 45.600" />
        <button type="button" class="btn secondary" (click)="parseReference()">Parse</button>

        <label class="block-label">Measure from (km)</label>
        <div class="row">
          <input type="number" step="0.001" [(ngModel)]="measureKm" (ngModelChange)="onMeasureKmChange()" />
          <button type="button" class="btn" (click)="interpolateFromInput()">Go</button>
        </div>
        <button type="button" class="btn secondary chainage-pick-btn" (click)="startChainagePick('from')">
          Set from on map
        </button>

        <label class="block-label" *ngIf="selectedAssetIsLinear">Measure to (km)</label>
        <input
          *ngIf="selectedAssetIsLinear"
          type="number"
          step="0.001"
          [(ngModel)]="measureToKm"
          (ngModelChange)="onMeasureToKmChange()"
        />
        <button
          type="button"
          class="btn secondary chainage-pick-btn"
          *ngIf="selectedAssetIsLinear"
          (click)="startChainagePick('to')"
        >
          Set to on map
        </button>

        <p class="chainage-error" *ngIf="chainageValidationError">{{ chainageValidationError }}</p>

        <div class="locate-card" *ngIf="locateResult">
          <div><strong>{{ locateResult.chainage_label }}</strong></div>
          <div>{{ locateResult.measure_km | number: '1.3-3' }} km</div>
        </div>

        <div class="boq-drill" *ngIf="selectedRoute">
          <h3>BOQ at this chainage</h3>
          <p class="hint">Items whose km range covers {{ measureKm | number:'1.3-3' }} km.</p>
          <div *ngIf="boqAtChainageLoading" class="hint">Loading BOQ…</div>
          <ul class="mini-list" *ngIf="!boqAtChainageLoading && boqAtChainage?.boqs?.length">
            <li *ngFor="let b of boqAtChainage!.boqs">
              <button type="button" class="link-btn" (click)="openBoqFromMap(b.boq_id)">{{ b.boq_code }}</button>
              <small>{{ b.item_count }} item(s) · {{ b.from_km | number:'1.1-1' }}–{{ b.to_km | number:'1.1-1' }} km</small>
            </li>
          </ul>
          <ul class="mini-list boq-item-list" *ngIf="!boqAtChainageLoading && boqAtChainage?.items?.length">
            <li *ngFor="let it of boqAtChainage!.items | slice:0:12">
              <strong>{{ it.item_code }}</strong>
              {{ it.item_description }}
              <small>{{ it.quantity }} {{ it.unit }}</small>
            </li>
          </ul>
          <p class="hint" *ngIf="!boqAtChainageLoading && !boqAtChainage?.item_count">No BOQ items for this km yet.</p>
          <button
            type="button"
            class="btn primary"
            (click)="generateBoqForRange()"
            [disabled]="generatingBoq || !resolvedProjectId() || assetsLocked"
          >
            {{ generatingBoq ? 'Creating…' : 'Generate BOQ for this range' }}
          </button>
        </div>

        <div class="chainage-tools">
          <label>Chainage interval (km)</label>
          <input type="number" step="0.5" min="0.5" [(ngModel)]="chainageIntervalKm" />
          <button type="button" class="btn secondary" (click)="generateChainageMarkers()">
            Generate km markers
          </button>
        </div>
      </section>

      <section *ngIf="selectedRoute" class="calib-block">
        <h2>Calibration points</h2>
        <p class="hint">Km stones / survey — min 2 per route (start + end).</p>
        <button type="button" class="btn secondary" (click)="addCalibrationAtChainage()">
          Add calibration &#64; {{ measureKm | number: '1.3-3' }} km
        </button>
        <div class="gps-row">
          <input type="number" step="0.000001" [(ngModel)]="gpsLng" placeholder="Lng" />
          <input type="number" step="0.000001" [(ngModel)]="gpsLat" placeholder="Lat" />
          <button type="button" class="btn secondary" (click)="gpsToChainageFromCoords()">GPS→CH</button>
        </div>
        <ul class="mini-list" *ngIf="calibrationPoints.length">
          <li *ngFor="let c of calibrationPoints">
            {{ c.chainage_label || (c.measure_m / 1000 | number: '1.3-3') + ' km' }}
            <small>{{ c.point_type }}</small>
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute" class="nhai-layers-card">
        <app-lrs-layer-tree
          [visibility]="nhaiLayerVisibility"
          [counts]="nhaiLayerCounts"
          [expanded]="nhaiExpandedGroups"
          [collapseGroupsByDefault]="sidebarPanelOnly"
          (visibilityChange)="onNhaiVisibility($event)"
          (expandedChange)="nhaiExpandedGroups = $event"
        ></app-lrs-layer-tree>
        <h3>Locate by edge offset</h3>
        <details class="locate-map-block" [open]="!sidebarPanelOnly">
          <summary>Locate at pavement edge</summary>
        <p class="hint">Find assets relative to the pavement edge (e.g. 3 m outside left edge at CH 125+380).</p>
        <label>Chainage
          <input [(ngModel)]="locateChainage" placeholder="125+380" />
        </label>
        <label>Side
          <select [(ngModel)]="locateSide">
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="C">Center</option>
          </select>
        </label>
        <label>Edge offset (m)
          <input type="number" step="0.1" [(ngModel)]="locateEdgeOffsetM" />
        </label>
        <button type="button" class="btn secondary" (click)="runLocateAtEdge()">Find</button>
        <p class="hint" *ngIf="locateStatus">{{ locateStatus }}</p>
        <ul class="mini-list" *ngIf="locateResults.length">
          <li *ngFor="let r of locateResults">
            {{ r.kind }} · {{ r.type }} · {{ r.label }}
            <small *ngIf="r.edge_offset_m != null">edge {{ r.edge_offset_m | number:'1.2-2' }} m</small>
          </li>
        </ul>
        </details>
      </section>

      <nav *ngIf="selectedRoute" class="workbench-tabs">
        <button type="button" *ngFor="let t of primaryWorkbenchTabs" [class.active]="activePanel === t.id" (click)="setActivePanel(t.id)">
          {{ t.label }}
        </button>
        <div class="workbench-more">
          <button type="button" class="workbench-more-btn" [class.active]="morePanelActive" (click)="moreMenuOpen = !moreMenuOpen">
            More
          </button>
          <div class="workbench-more-menu" *ngIf="moreMenuOpen">
            <button type="button" *ngFor="let t of moreWorkbenchTabs" [class.active]="activePanel === t.id" (click)="setActivePanel(t.id); moreMenuOpen = false">
              {{ t.label }}
            </button>
          </div>
        </div>
      </nav>

      <section *ngIf="selectedRoute && activePanel === 'assets'" class="asset-mgmt">
        <h2>Highway assets (events)</h2>
        <p class="hint">Signs, culverts, bridges, crash barriers, lighting — stored as LRS events.</p>
        <p class="error" *ngIf="assetsLocked">Assets are locked until Map → Road → LRS all pass.</p>

        <label class="block-label">Search assets</label>
        <input
          type="search"
          [(ngModel)]="assetSearchQuery"
          (ngModelChange)="onAssetSearchChange()"
          placeholder="Label, type, ref, or CH 12+500"
        />
        <ul class="event-list search-hits" *ngIf="assetSearchQuery.trim() && assetSearchHits.length">
          <li
            *ngFor="let hit of assetSearchHits"
            class="event-list-item"
            [class.selected]="assetDetailOpen && selectedAssetId === hit.id"
            (click)="openAssetSearchHit(hit)"
          >
            <img class="etype-icon" [src]="assetIconPath(hit.type)" [alt]="hit.type" width="18" height="18" />
            <span class="etype-badge" [style.background]="assetColor(hit.type)">{{ hit.type }}</span>
            <span class="search-hit-kind">{{ hit.kind }}</span>
            <span class="ch">{{ hit.chainage }}</span>
            <span class="lbl">{{ hit.label }}</span>
          </li>
        </ul>
        <p class="hint" *ngIf="assetSearchQuery.trim() && !assetSearchHits.length">
          No assets match “{{ assetSearchQuery }}”. Chainage-like queries still pan the map.
        </p>

        <div class="place-row">
          <button
            type="button"
            class="btn secondary"
            [class.active]="placeAssetMode"
            (click)="togglePlaceAssetMode()"
            [disabled]="assetsLocked"
          >
            {{ placeAssetMode ? 'Placing on map…' : 'Place on map' }}
          </button>
        </div>
        <p class="hint" *ngIf="placeAssetMode">{{ placeAssetHint }}</p>

        <div class="asset-type-grid">
          <button
            type="button"
            *ngFor="let t of assetTypes"
            class="asset-type-btn"
            [class.active]="newEventType === t.id"
            [style.--asset-color]="t.color"
            (click)="selectAssetType(t.id)"
          >
            <img class="icon-svg" [src]="t.iconPath" [alt]="t.label" width="24" height="24" />
            <span class="lbl">{{ t.label }}</span>
            <span class="cnt" *ngIf="assetCounts[t.id]">{{ assetCounts[t.id] }}</span>
          </button>
        </div>

        <label class="block-label">Filter</label>
        <select [(ngModel)]="assetFilterType" (ngModelChange)="applyAssetFilter()">
          <option value="">All highway assets</option>
          <option *ngFor="let t of assetTypes" [value]="t.id">{{ t.label }}</option>
        </select>
        <label>From km
          <input type="number" step="0.001" [(ngModel)]="assetFilterFromKm" (ngModelChange)="applyAssetFilter()" placeholder="0" />
        </label>
        <label>To km
          <input type="number" step="0.001" [(ngModel)]="assetFilterToKm" (ngModelChange)="applyAssetFilter()" placeholder="end" />
        </label>
        <label>Offset from (m)
          <input type="number" step="0.1" [(ngModel)]="assetFilterOffsetFromM" (ngModelChange)="applyAssetFilter()" placeholder="0" />
        </label>
        <label>Offset to (m)
          <input type="number" step="0.1" [(ngModel)]="assetFilterOffsetToM" (ngModelChange)="applyAssetFilter()" placeholder="any" />
        </label>
        <label>Side
          <select [(ngModel)]="assetFilterSide" (ngModelChange)="applyAssetFilter()">
            <option value="">Any</option>
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="C">Center</option>
          </select>
        </label>
        <label>As of (history)
          <input type="datetime-local" [(ngModel)]="historyAtTime" (ngModelChange)="onHistoryTimeChange()" />
        </label>
        <p class="hint" *ngIf="historyAtTime">Showing route + assets valid at {{ historyAtTime }} — clear to view current.</p>

        <label class="block-label">Bulk import (CSV)</label>
        <textarea
          rows="4"
          [(ngModel)]="bulkImportCsv"
          placeholder="measure_km,event_type,label,side,offset_m&#10;12.5,sign,KM 12.5,L,2"
        ></textarea>
        <button type="button" class="btn secondary" (click)="bulkImportAssetsFromCsv()" [disabled]="!selectedRouteId || assetsLocked">
          Import assets from CSV
        </button>

        <label>Label <input [(ngModel)]="newEventLabel" [placeholder]="assetLabelPlaceholder" /></label>
        <label>Asset ref <input [(ngModel)]="assetRef" placeholder="INV-001" /></label>
        <label>Side
          <select [(ngModel)]="assetSide">
            <option value="">—</option>
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="C">Center</option>
          </select>
        </label>
        <label>Condition
          <select [(ngModel)]="conditionGrade">
            <option value="">—</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>
        </label>
        <label>Lateral offset from median (m)
          <input type="number" step="0.5" min="0" [(ngModel)]="lateralOffsetM" placeholder="Distance from centerline" />
        </label>
        <label>Offset from road edge (m)
          <input type="number" step="0.1" [(ngModel)]="edgeOffsetM" placeholder="Outside pavement; blank = derive" />
        </label>
        <label>Grade
          <select [(ngModel)]="highwayGrade">
            <option *ngFor="let g of grades" [value]="g.id">{{ g.label }}</option>
          </select>
        </label>
        <ng-container *ngFor="let f of createExtraFields">
          <label>{{ f.label }}<span *ngIf="f.unit"> ({{ f.unit }})</span>
            <input *ngIf="f.kind !== 'date'" [type]="f.kind === 'number' ? 'number' : 'text'" [(ngModel)]="createSpecValues[f.key]" [name]="'spec-'+f.key" />
            <input *ngIf="f.kind === 'date'" type="date" [(ngModel)]="createSpecValues[f.key]" [name]="'spec-'+f.key" />
          </label>
        </ng-container>
        <p class="hint" *ngIf="assetSide === 'L' || assetSide === 'R'">
          Left/right applies sign automatically (default 2 m if offset is 0).
        </p>
        <label>Event behavior
          <select [(ngModel)]="eventBehavior">
            <option *ngFor="let b of eventBehaviors" [value]="b.id">{{ b.label }}</option>
          </select>
        </label>
        <label>Valid from <input type="datetime-local" [(ngModel)]="assetValidFrom" /></label>
        <label>Valid to <input type="datetime-local" [(ngModel)]="assetValidTo" /></label>

        <button type="button" class="btn secondary" (click)="previewOffsetGeometry()">Preview offset on map</button>
        <button type="button" class="btn secondary" (click)="reapplyAssetOffsets()">Reposition all assets (side/offset)</button>
        <button type="button" class="btn primary" (click)="addAssetEvent()" [disabled]="assetsLocked">
          Save {{ selectedAssetLabel }} at chainage
        </button>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'attributes'" class="attr-block">
        <h2>Linear attribute events</h2>
        <p class="hint">Pavement, geometry, cross-section — dynamic segmentation (from–to km).</p>
        <label>Type
          <select [(ngModel)]="attributeEventType">
            <option *ngFor="let t of linearEventTypes" [value]="t.id">{{ t.label }}</option>
          </select>
        </label>
        <label>Label <input [(ngModel)]="attributeLabel" /></label>
        <label>JSON data <input [(ngModel)]="attributeDataJson" placeholder='{"lanes":4}' /></label>
        <button type="button" class="btn primary" (click)="saveAttributeEvent()">Save attribute segment</button>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'survey'" class="survey-block">
        <h2>NSV / pavement condition</h2>
        <button type="button" class="btn secondary" (click)="createSurveyRun()">New measurement run</button>
        <ul class="mini-list" *ngIf="measurementRuns.length">
          <li *ngFor="let r of measurementRuns" (click)="selectedRunId = r.id" [class.active]="selectedRunId === r.id">
            {{ r.run_date }} · {{ r.vehicle_id || 'survey' }}
          </li>
        </ul>
        <label>PCI (0–100) <input type="number" [(ngModel)]="pciValue" /></label>
        <label>IRI <input type="number" step="0.1" [(ngModel)]="iriValue" /></label>
        <label>Surface <input [(ngModel)]="surfaceType" placeholder="BT / CC" /></label>
        <button type="button" class="btn primary" (click)="savePavementSegment()">Save PCI segment (current km range)</button>
        <ul class="mini-list" *ngIf="pavementConditions.length">
          <li *ngFor="let p of pavementConditions">
            {{ p.from_km | number:'1.2-2' }}–{{ p.to_km | number:'1.2-2' }} km · PCI {{ p.pci ?? '—' }}
          </li>
        </ul>

        <h3>Survey deviation (field vs LRS)</h3>
        <p class="hint">TC-LRS-13: paste GPS/Total Station observations — lng,lat,field_measure_km[,label]. Limits: ±2 m GPS, ±5 m/km, ±0.5 m lateral.</p>
        <textarea
          rows="4"
          [(ngModel)]="surveyObservationsCsv"
          placeholder="lng,lat,field_measure_km,label&#10;78.515,17.392,1.000,KM-1 stone"
        ></textarea>
        <button type="button" class="btn primary" (click)="runSurveyDeviation()" [disabled]="!selectedRouteId">
          Compare field vs LRS
        </button>
        <button type="button" class="btn secondary" (click)="runAcceptanceEvidence()" [disabled]="!selectedRouteId">
          Run acceptance pack
        </button>
        <div class="qc-block" *ngIf="acceptanceReport" [class.qc-ok]="acceptanceReport.ok" [class.qc-fail]="!acceptanceReport.ok">
          <h3>Acceptance {{ acceptanceReport.ok ? 'OK' : 'Review' }}</h3>
          <ul class="qc-list">
            <li *ngFor="let c of acceptanceReport.checks" [class]="c.ok ? 'sev-info' : 'sev-error'">
              {{ c.tc }} {{ c.title }} — {{ c.ok ? 'Pass' : 'Fail' }}
            </li>
          </ul>
        </div>
        <div class="qc-block" *ngIf="surveyReport" [class.qc-ok]="surveyReport.ok" [class.qc-fail]="!surveyReport.ok">
          <h3>Deviation {{ surveyReport.ok ? 'OK' : 'Review' }}</h3>
          <p class="hint">
            {{ surveyReport.within_tolerance_count }}/{{ surveyReport.valid_count }} within tolerance ·
            max {{ surveyReport.max_abs_deviation_m ?? '—' }} m ·
            mean {{ surveyReport.mean_abs_deviation_m ?? '—' }} m ·
            GPS ±{{ surveyReport.tolerance.max_abs_deviation_m ?? 2 }} m ·
            ±{{ surveyReport.tolerance.max_error_m_per_km }} m/km ·
            offset ±{{ surveyReport.tolerance.max_lateral_offset_m ?? 0.5 }} m
          </p>
          <ul class="qc-list">
            <li *ngFor="let o of surveyReport.observations" [class]="o.within_tolerance ? 'sev-info' : 'sev-error'">
              {{ o.label }}: field {{ o.field_measure_km }} km → LRS {{ o.lrs_measure_km }} km
              ({{ o.deviation_m }} m, {{ o.error_m_per_km }} m/km, lat {{ o.lateral_offset_m }} m)
              <span *ngIf="o.error">— {{ o.error }}</span>
            </li>
          </ul>
          <button type="button" class="btn secondary" (click)="exportSurveyDeviation('csv')">Export CSV</button>
          <button type="button" class="btn secondary" (click)="exportSurveyDeviation('json')">Export JSON</button>
          <button type="button" class="btn secondary" (click)="exportSurveyDeviation('pdf')">Export PDF</button>
        </div>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'maintenance'" class="maint-block">
        <h2>Maintenance history</h2>
        <label>Work type <input [(ngModel)]="maintWorkType" placeholder="overlay / pothole" /></label>
        <label>Contractor <input [(ngModel)]="maintContractor" /></label>
        <label>Cost (₹) <input type="number" [(ngModel)]="maintCostInr" /></label>
        <label>Warranty (months) <input type="number" [(ngModel)]="maintWarrantyMonths" /></label>
        <button type="button" class="btn primary" (click)="saveMaintenance()">Log work at km range</button>
        <ul class="mini-list" *ngIf="maintenanceEvents.length">
          <li *ngFor="let m of maintenanceEvents">
            {{ m.work_type }} · {{ (m.from_measure_m/1000) | number:'1.2-2' }}–{{ (m.to_measure_m/1000) | number:'1.2-2' }} km
            <small *ngIf="m.cost_inr">₹{{ m.cost_inr | number }}</small>
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'utilities'" class="util-block">
        <h2>Corridor utilities</h2>
        <div class="asset-type-grid util-grid">
          <button
            type="button"
            *ngFor="let u of utilityTypes"
            class="asset-type-btn"
            [class.active]="utilityType === u.id"
            [style.--asset-color]="u.color"
            (click)="selectUtilityType(u.id)"
          >
            <img class="icon-svg" [src]="u.iconPath" [alt]="u.label" width="22" height="22" />
            <span class="lbl">{{ u.label }}</span>
          </button>
        </div>
        <label>Label <input [(ngModel)]="utilityLabel" /></label>
        <label>Grade
          <select [(ngModel)]="utilityGrade">
            <option *ngFor="let g of grades" [value]="g.id">{{ g.label }}</option>
          </select>
        </label>
        <label>Depth (m) <input type="number" step="0.1" [(ngModel)]="utilityDepthM" (ngModelChange)="onUtilityDepthChange()" /></label>
        <label>Diameter (mm) <input type="number" [(ngModel)]="utilityDiameterMm" /></label>
        <label>Offset from median (m)
          <input type="number" step="0.5" [(ngModel)]="lateralOffsetM" />
        </label>
        <label>Offset from road edge (m)
          <input type="number" step="0.1" [(ngModel)]="edgeOffsetM" placeholder="Blank = derive from carriageway" />
        </label>
        <ng-container *ngFor="let f of createExtraFields">
          <label>{{ f.label }}<span *ngIf="f.unit"> ({{ f.unit }})</span>
            <input *ngIf="f.kind !== 'date'" [type]="f.kind === 'number' ? 'number' : 'text'" [(ngModel)]="createSpecValues[f.key]" [name]="'uspec-'+f.key" />
            <input *ngIf="f.kind === 'date'" type="date" [(ngModel)]="createSpecValues[f.key]" [name]="'uspec-'+f.key" />
          </label>
        </ng-container>
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="utilityIsLinear" /> Linear run (use to-km)
        </label>
        <button type="button" class="btn primary" (click)="saveUtilityAsset()">Save utility</button>
        <ul class="mini-list" *ngIf="filteredUtilityAssets.length">
          <li
            *ngFor="let u of filteredUtilityAssets"
            class="clickable"
            [class.selected]="assetDetailOpen && selectedAssetId === u.id && assetDetailKind === 'utility'"
            (click)="openUtilityFromList(u)"
          >
            {{ u.utility_type }} · {{ u.grade || 'overground' }} · {{ u.label }} &#64; {{ u.measure_m/1000 | number:'1.3-3' }} km
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'network'" class="network-block">
        <h2>Carriageways / lanes</h2>
        <label>Code <select [(ngModel)]="carriagewayCode"><option>MAIN</option><option>SERVICE</option><option>RAMP</option></select></label>
        <label>Lanes <input type="number" [(ngModel)]="carriagewayLanes" min="1" /></label>
        <label>Lateral offset (m) <input type="number" step="0.5" [(ngModel)]="carriagewayOffsetM" /></label>
        <label>Direction <select [(ngModel)]="carriagewayDirection"><option>BOTH</option><option>UP</option><option>DOWN</option></select></label>
        <button type="button" class="btn primary" (click)="saveCarriageway()">Add carriageway span</button>
        <ul class="mini-list" *ngIf="carriageways.length">
          <li *ngFor="let c of carriageways">
            {{ c.carriageway_code }} · {{ c.lane_count }} lanes
            <ng-container *ngIf="c.lateral_offset_m"> · offset {{ c.lateral_offset_m }}m</ng-container>
            · {{ (c.from_measure_m/1000)|number:'1.1-1' }} km+
          </li>
        </ul>

        <h3>Per-lane geometry (merge / diverge / weave)</h3>
        <p class="hint">Lanes are calibration-aware offset ribbons; tapered offsets model merge/diverge transitions (SRS §5).</p>
        <div class="row">
          <button type="button" class="btn" (click)="generateLanesForCarriageway()">Generate lanes from carriageway</button>
          <label class="check-row">
            <input type="checkbox" [ngModel]="lanesMode" (ngModelChange)="toggleLanes()" />
            Show lanes on map
          </label>
        </div>
        <ul class="mini-list" *ngIf="lanesMode && lanes.length">
          <li *ngFor="let l of lanes">
            {{ l.lane_code || ('Lane ' + l.lane_number) }} · {{ l.transition_type }}
            · {{ l.start_offset_m | number:'1.0-1' }}→{{ l.end_offset_m | number:'1.0-1' }}m
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'unm'" class="unm-block">
        <h2>Utility Network (UNM)</h2>
        <p class="hint">Click assets on the map to connect (from → to). Trace path is drawn on the route. Server rules are authoritative.</p>
        <div class="unm-legend">
          <span><i class="swatch tx"></i> Transmission</span>
          <span><i class="swatch dist"></i> Distribution</span>
          <span><i class="swatch svc"></i> Service</span>
          <span><i class="swatch iso"></i> Isolator</span>
        </div>
        <label class="check-row">
          <input type="checkbox" [(ngModel)]="unmConnectPickMode" />
          Click map to connect ({{ unmPickStep === 'from' ? 'pick from' : 'pick to' }})
        </label>

        <h3>Create asset</h3>
        <label>Domain
          <select [(ngModel)]="unmDomainId" (ngModelChange)="onUnmDomainChange()">
            <option [ngValue]="null" disabled>Select domain</option>
            <option *ngFor="let d of unmDomains" [ngValue]="d.domain_id">{{ d.domain_name }}</option>
          </select>
        </label>
        <label>Tier
          <select [(ngModel)]="unmTierId">
            <option [ngValue]="null">Default</option>
            <option *ngFor="let t of unmSelectedDomainTiers" [ngValue]="t.tier_id">{{ t.tier_name }}</option>
          </select>
        </label>
        <label>Type
          <select [(ngModel)]="unmAssetType" (ngModelChange)="onUnmAssetTypeChange()">
            <option>FIBER</option>
            <option>CABINET</option>
            <option>JUNCTION</option>
            <option>DUCT</option>
            <option>CABLE</option>
            <option>TRANSFORMER</option>
            <option>SUBSTATION</option>
            <option>STREET_LIGHT</option>
            <option>CAMERA</option>
            <option>POLE</option>
            <option>PIPE</option>
            <option>VALVE</option>
          </select>
        </label>
        <label>Code <input [(ngModel)]="unmAssetCode" placeholder="OFC-001" /></label>
        <label>Name <input [(ngModel)]="unmAssetName" /></label>
        <label>Chainage (km) <input type="number" step="0.001" [(ngModel)]="unmChainageKm" /></label>
        <label>Offset (m) <input type="number" step="0.1" [(ngModel)]="unmOffsetM" /></label>
        <label>Side
          <select [(ngModel)]="unmOffsetSide">
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="C">Center</option>
          </select>
        </label>
        <label>Depth (m) <input type="number" step="0.1" [(ngModel)]="unmDepthM" /></label>
        <ng-container *ngFor="let f of unmPropertyFields">
          <label>{{ f.label }}
            <select *ngIf="f.type === 'enum'" [(ngModel)]="unmProperties[f.name]">
              <option value="">—</option>
              <option *ngFor="let v of f.values" [value]="v">{{ v }}</option>
            </select>
            <input *ngIf="f.type !== 'enum'" [type]="f.type === 'string' ? 'text' : 'number'" [(ngModel)]="unmProperties[f.name]" />
          </label>
        </ng-container>
        <button type="button" class="btn primary" (click)="saveUnmAsset()">Create UNM asset</button>
        <button type="button" class="btn secondary" (click)="refreshUnmAssets()">Refresh</button>

        <ul class="mini-list" *ngIf="unmAssets.length">
          <li *ngFor="let a of unmAssets" class="unm-asset-row">
            <button type="button" class="link-btn" (click)="pickUnmAssetFromList(a, 'from')">
              #{{ a.asset_id }} · {{ a.asset_type }} · {{ a.asset_code }}
              <ng-container *ngIf="a.tier_name"> · {{ a.tier_name }}</ng-container>
              <ng-container *ngIf="a.chainage_m != null"> &#64; {{ a.chainage_m/1000 | number:'1.3-3' }} km</ng-container>
              <ng-container *ngIf="a.node_id"> · node {{ a.node_id }}</ng-container>
            </button>
            <span class="unm-asset-actions">
              <button type="button" class="link-btn" (click)="pickUnmAssetFromList(a, 'to')">to</button>
              <button type="button" class="link-btn" (click)="pickUnmAssetFromList(a, 'trace')">trace</button>
            </span>
          </li>
        </ul>

        <h3>Connect nodes</h3>
        <label>From node <input type="number" [(ngModel)]="unmFromNodeId" /></label>
        <label>To node <input type="number" [(ngModel)]="unmToNodeId" /></label>
        <button type="button" class="btn primary" (click)="connectUnmNodes()">Connect</button>

        <h3>Trace</h3>
        <label>Start node <input type="number" [(ngModel)]="unmTraceNodeId" /></label>
        <label>Direction
          <select [(ngModel)]="unmTraceDirection">
            <option value="downstream">Downstream</option>
            <option value="upstream">Upstream</option>
            <option value="connected">Connected</option>
            <option value="isolation">Isolation</option>
          </select>
        </label>
        <button type="button" class="btn primary" (click)="runUnmTrace()">Run trace</button>
        <ul class="mini-list" *ngIf="unmTraceResults.length">
          <li *ngFor="let t of unmTraceResults">
            depth {{ t.depth }} · {{ t.asset_type }} · {{ t.asset_name }} (node {{ t.node_id }})
            <span *ngIf="t.is_isolator" class="unm-iso-tag">isolator</span>
          </li>
        </ul>

        <h3>Containment</h3>
        <label>Container asset id <input type="number" [(ngModel)]="unmContainerAssetId" /></label>
        <label>Contained asset id <input type="number" [(ngModel)]="unmContainedAssetId" /></label>
        <button type="button" class="btn secondary" (click)="saveUnmContainment()">Add containment</button>

        <h3>Attachment</h3>
        <label>Structure asset id <input type="number" [(ngModel)]="unmStructureAssetId" /></label>
        <label>Attached asset id <input type="number" [(ngModel)]="unmAttachedAssetId" /></label>
        <button type="button" class="btn secondary" (click)="saveUnmAttachment()">Add attachment</button>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'corridor'" class="dyn-seg-block">
        <h2>Corridor inventory</h2>
        <p class="hint">PDF query: assets + PCI + maintenance + utilities for km range. Offset filter applies to assets and utilities.</p>
        <div class="row">
          <input type="number" step="0.1" [(ngModel)]="segFromKm" />
          <input type="number" step="0.1" [(ngModel)]="segToKm" />
        </div>
        <label>Offset from (m)
          <input type="number" step="0.1" [(ngModel)]="corridorOffsetFromM" placeholder="0" />
        </label>
        <label>Offset to (m)
          <input type="number" step="0.1" [(ngModel)]="corridorOffsetToM" placeholder="any" />
        </label>
        <label>Side
          <select [(ngModel)]="corridorFilterSide">
            <option value="">Any</option>
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="C">Center</option>
          </select>
        </label>
        <button type="button" class="btn primary" (click)="loadCorridorInventory()">Load corridor</button>
        <button type="button" class="btn secondary" (click)="previewDynamicSegment()">Map preview</button>
        <button type="button" class="btn secondary" (click)="exportCorridorGeoJson()">Export GeoJSON</button>
        <div class="corridor-summary" *ngIf="corridorSummary">
          <div *ngFor="let item of corridorSummary | keyvalue">{{ item.key }}: {{ item.value }}</div>
        </div>
        <div class="qc-block" *ngIf="corridorLayerQa">
          <h3>Layer QA {{ corridorLayerQa.ok ? 'OK' : 'Review' }}</h3>
          <ul class="mini-list">
            <li *ngFor="let layer of corridorLayerQa.layers">{{ layer.label }}: {{ layer.count }}</li>
          </ul>
          <p class="hint" *ngFor="let n of corridorLayerQa.notes">{{ n }}</p>
        </div>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'route'" class="route-block">
        <h2>Edit route</h2>
        <div class="route-readout">
          <span>Origin {{ routeOriginKm | number:'1.3-3' }} km</span>
          <span>Length {{ routeLengthKm | number:'1.3-3' }} km</span>
          <span>End {{ routeEndKm | number:'1.3-3' }} km</span>
        </div>
        <label>Code <input type="text" [(ngModel)]="routeEditCode" /></label>
        <label>Name <input type="text" [(ngModel)]="routeEditName" /></label>
        <label>Origin (km) <input type="number" step="0.001" [(ngModel)]="routeEditOriginKm" /></label>

        <h3>Design attributes (IRC:73)</h3>
        <label>Design speed (km/h)
          <select [(ngModel)]="routeEditDesignSpeed">
            <option [ngValue]="null">—</option>
            <option *ngFor="let s of designSpeeds" [ngValue]="s">{{ s }}</option>
          </select>
        </label>
        <label>Terrain
          <select [(ngModel)]="routeEditTerrain">
            <option value="">—</option>
            <option *ngFor="let t of terrainTypes" [value]="t.id">{{ t.label }}</option>
          </select>
        </label>
        <label>ROW width (m) <input type="number" step="0.5" min="0" [(ngModel)]="routeEditRowWidth" /></label>
        <label>Carriageway
          <select [(ngModel)]="routeEditCarriageway">
            <option value="">—</option>
            <option *ngFor="let c of carriagewayConfigs" [value]="c">{{ c }}</option>
          </select>
        </label>
        <button type="button" class="btn secondary" (click)="saveRouteMetadata()">Save metadata</button>
        <button type="button" class="btn secondary" (click)="syncRouteLengthFromGeometry()">Sync length from geometry</button>

        <h3>Draw / edit centerline</h3>
        <p class="hint">Add vertices while drawing for curves, or edit an existing route on the map.</p>
        <button type="button" class="btn secondary" [class.active]="routeEditVerticesMode" (click)="toggleEditRouteVertices()">
          {{ routeEditVerticesMode ? 'Editing vertices…' : 'Edit vertices on map' }}
        </button>
        <button type="button" class="btn secondary" *ngIf="routeEditVerticesMode" (click)="densifyRouteVertices()">
          Add curve vertices
        </button>
        <button type="button" class="btn primary" *ngIf="routeEditVerticesMode" (click)="saveEditedRouteGeometry()">
          Save centerline
        </button>

        <h3>Increase / decrease length</h3>
        <p class="hint">Adjust measure domain at start or end (geometry unchanged). Use retire when shortening past assets.</p>
        <label>Change
          <select [(ngModel)]="routeLengthMode">
            <option *ngFor="let m of routeLengthModes" [value]="m.id">{{ m.label }}</option>
          </select>
        </label>
        <label>Position
          <select [(ngModel)]="extendPosition">
            <option value="end">End</option>
            <option value="start">Start</option>
          </select>
        </label>
        <label>Amount (m) <input type="number" min="1" step="1" [(ngModel)]="extendMeters" /></label>
        <label>Event behavior
          <select [(ngModel)]="extendBehavior">
            <option *ngFor="let b of eventBehaviors" [value]="b.id">{{ b.label }}</option>
          </select>
        </label>
        <button type="button" class="btn primary" (click)="applyRouteLengthAdjust()">
          {{ routeLengthMode === 'increase' ? 'Increase' : 'Decrease' }} length
        </button>

        <h3>Set target length</h3>
        <label>Target length (km)
          <input type="number" step="0.001" min="0.01" [(ngModel)]="routeTargetLengthKm" />
        </label>
        <button type="button" class="btn secondary" (click)="applyRouteTargetLength()">Apply target length</button>

        <button type="button" class="btn secondary" [class.active]="realignDrawMode" (click)="toggleRealignRoute()">
          {{ realignDrawMode ? 'Drawing realign…' : 'Realign centerline' }}
        </button>
        <p class="hint">Realign replaces geometry; a snapshot is stored first. Run “Sync length from geometry” or QC after.</p>
        <h3>Geometry snapshots</h3>
        <button type="button" class="btn secondary" (click)="captureGeometrySnapshot()" [disabled]="!selectedRouteId">
          Capture snapshot
        </button>
        <p class="hint">As-of map uses the latest snapshot at or before the history time.</p>
        <ul class="mini-list" *ngIf="routeSnapshots.length">
          <li *ngFor="let s of routeSnapshots">
            <button type="button" class="link-btn" (click)="viewSnapshot(s)">
              {{ s.reason }} · {{ s.captured_at | date:'short' }} · {{ (s.length_m / 1000) | number:'1.2-2' }} km
            </button>
          </li>
        </ul>
        <ul class="mini-list" *ngIf="routeExtensions.length">
          <li *ngFor="let x of routeExtensions">
            {{ x.position }}
            <ng-container *ngIf="x.extend_m >= 0">+{{ x.extend_m }}</ng-container>
            <ng-container *ngIf="x.extend_m < 0">{{ x.extend_m }}</ng-container>
            m · {{ x.event_behavior }} · {{ x.events_affected }} events
            <small>{{ x.created_at | date:'short' }}</small>
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'clash'" class="clash-block">
        <h2>Excavation clash detection</h2>
        <p class="hint">Utilities, bridges, shallow depth — before issuing dig permit.</p>
        <div class="row">
          <input type="number" step="0.1" [(ngModel)]="segFromKm" />
          <input type="number" step="0.1" [(ngModel)]="segToKm" />
        </div>
        <label>Max dig depth (m) <input type="number" step="0.1" [(ngModel)]="clashMaxDepthM" /></label>
        <label>Min vertical sep (m) <input type="number" step="0.1" [(ngModel)]="clashMinVerticalSepM" /></label>
        <label>Min 3D sep (m) <input type="number" step="0.1" [(ngModel)]="clashMin3dSepM" /></label>
        <button type="button" class="btn primary" (click)="runClashDetection()">Detect clashes</button>
        <button type="button" class="btn secondary" (click)="exportClash3dGeoJson()" [disabled]="!selectedRouteId">
          Export 3D GeoJSON
        </button>
        <button type="button" class="btn secondary" (click)="saveExcavationPermit()">Save excavation permit</button>
        <button type="button" class="btn primary" (click)="runUnmPermitAssess()" [disabled]="unmAssessing">
          {{ unmAssessing ? 'Assessing…' : 'UNM permit assess' }}
        </button>
        <button type="button" class="btn secondary" (click)="runClashDetection()" *ngIf="clashReport">Refresh map</button>
        <label>Excavation width (m) <input type="number" step="0.5" [(ngModel)]="unmPermitWidthM" /></label>
        <ul class="mini-list" *ngIf="excavationPermits.length">
          <li *ngFor="let p of excavationPermits">
            {{ p.permit_ref || ('#' + p.id) }} · {{ p.from_km | number:'1.1-1' }}–{{ p.to_km | number:'1.1-1' }} km · {{ p.status }}
          </li>
        </ul>
        <div *ngIf="unmPermitResult" class="clash-report" [class.clash-ok]="unmPermitResult.riskLevel === 'LOW'" [class.clash-fail]="unmPermitResult.riskLevel === 'HIGH'">
          <p><strong>UNM risk: {{ unmPermitResult.riskLevel }}</strong> (score {{ unmPermitResult.riskScore }})</p>
          <p>Approvals: {{ unmPermitResult.requiredApprovals?.join(', ') }}</p>
          <p>Direct: {{ unmPermitResult.impactedDirectAssets?.length || 0 }} ·
             Deps: {{ unmPermitResult.dependencyAssets?.length || 0 }} ·
             Outage: {{ unmPermitResult.affectedOutageAssets?.length || 0 }}
            <ng-container *ngIf="unmPermitResult.outage?.outage_id">
              · saved #{{ unmPermitResult.outage.outage_id }}
            </ng-container>
          </p>
        </div>
        <div *ngIf="clashReport" class="clash-report" [class.clash-ok]="clashReport.ok" [class.clash-fail]="!clashReport.ok">
          <p><strong>{{ clashReport.recommendation }}</strong></p>
          <p>{{ clashReport.critical_count }} critical · {{ clashReport.high_count }} high · {{ clashReport.clash_count }} total</p>
          <p class="hint" *ngIf="clashReport.three_d">
            3D thresholds: vert ≥ {{ clashReport.min_vertical_sep_m }} m · 3D ≥ {{ clashReport.min_3d_sep_m }} m
          </p>
          <ul class="qc-list">
            <li *ngFor="let c of clashReport.clashes" [class]="'sev-' + c.severity">
              {{ c.message }}
              <small *ngIf="c.horizontal_sep_m != null">
                · H {{ c.horizontal_sep_m }} m
                <ng-container *ngIf="c.vertical_sep_m != null"> · V {{ c.vertical_sep_m }} m</ng-container>
                <ng-container *ngIf="c.three_d_sep_m != null"> · 3D {{ c.three_d_sep_m }} m</ng-container>
              </small>
            </li>
          </ul>
        </div>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'reports'" class="reports-block">
        <h2>NHA reports</h2>
        <p class="hint">TC-LRS-24: SLD, asset/utility inventory, calibration &amp; QC — PDF / Excel / CSV.</p>
        <label>Report type
          <select [(ngModel)]="reportType" (ngModelChange)="reportPreview = null">
            <option *ngFor="let r of reportCatalog" [value]="r.id">{{ r.title }}</option>
            <option *ngIf="!reportCatalog.length" value="asset-inventory">Asset Inventory</option>
          </select>
        </label>
        <label>Format
          <select [(ngModel)]="reportFormat">
            <option value="xlsx">Excel (.xlsx)</option>
            <option value="csv">CSV</option>
            <option value="pdf">PDF</option>
            <option value="json">JSON</option>
          </select>
        </label>
        <div class="row" *ngIf="reportNeedsRange()">
          <label>From km <input type="number" step="0.1" [(ngModel)]="segFromKm" /></label>
          <label>To km <input type="number" step="0.1" [(ngModel)]="segToKm" /></label>
        </div>
        <button type="button" class="btn primary" (click)="exportLrsReport()">Export report</button>
        <button type="button" class="btn secondary" (click)="previewLrsReport()">Preview</button>
        <button type="button" class="btn secondary" (click)="loadReportCatalog()">Refresh catalog</button>
        <h3>Shapefile</h3>
        <label>Layer
          <select [(ngModel)]="shapefileLayer">
            <option value="all">All (route + events + utilities + clash)</option>
            <option value="route">Centerline</option>
            <option value="events">Events</option>
            <option value="utilities">Utilities</option>
            <option value="clash">3D clash points</option>
          </select>
        </label>
        <button type="button" class="btn secondary" (click)="exportShapefile()" [disabled]="!selectedRouteId">
          Export shapefile ZIP
        </button>
        <div class="corridor-summary" *ngIf="reportPreview">
          <p><strong>{{ reportPreview.meta.title }}</strong> · {{ reportPreview.rows.length }} rows</p>
          <p class="hint" *ngIf="reportPreview.summary">
            <span *ngFor="let item of reportPreview.summary | keyvalue">{{ item.key }}: {{ item.value }} · </span>
          </p>
          <table class="report-preview-table" *ngIf="reportPreview.rows.length">
            <thead>
              <tr>
                <th *ngFor="let c of reportPreview.columns">{{ c.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of reportPreview.rows | slice:0:15">
                <td *ngFor="let c of reportPreview.columns">{{ row[c.key] }}</td>
              </tr>
            </tbody>
          </table>
          <p class="hint" *ngIf="reportPreview.rows.length > 15">Showing first 15 of {{ reportPreview.rows.length }} rows.</p>
        </div>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'alignment'" class="alignment-block">
        <h2>Vertical alignment</h2>
        <p class="hint">PVI / vertical-curve table along the existing 2D centerline. T1/T2 = PVI ± L/2. K = L / |g2 − g1|.</p>
        <p class="hint" *ngIf="alignmentStatus">{{ alignmentStatus }}</p>
        <div class="alignment-form">
          <label>Label <input [(ngModel)]="pviLabel" placeholder="VPI1" /></label>
          <label>Chainage (km) <input type="number" step="0.001" [(ngModel)]="pviMeasureKm" /></label>
          <label>Elevation (m) <input type="number" step="0.01" [(ngModel)]="pviElevM" /></label>
          <label>g1 (%) <input type="number" step="0.01" [(ngModel)]="pviGradeIn" /></label>
          <label>g2 (%) <input type="number" step="0.01" [(ngModel)]="pviGradeOut" /></label>
          <label>L (m) <input type="number" step="1" [(ngModel)]="pviCurveLengthM" /></label>
          <button type="button" class="btn primary" (click)="savePvi()">{{ pviEditId ? 'Update PVI' : 'Add PVI' }}</button>
          <button type="button" class="btn secondary" *ngIf="pviEditId" (click)="clearPviForm()">Cancel</button>
        </div>
        <table class="alignment-table" *ngIf="verticalPvis.length">
          <thead>
            <tr>
              <th>Label</th>
              <th>Chainage</th>
              <th>Elev</th>
              <th>g1</th>
              <th>g2</th>
              <th>L</th>
              <th>K</th>
              <th>Kind</th>
              <th>T1</th>
              <th>T2</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of verticalPvis" [class.selected]="pviEditId === p.id" (click)="beginEditPvi(p)">
              <td>{{ p.label || '—' }}</td>
              <td>{{ p.chainage_label || formatChainageFromMeters(p.pvi_measure_m) }}</td>
              <td>{{ p.pvi_elevation_m | number:'1.1-2' }}</td>
              <td>{{ p.grade_in_pct | number:'1.2-2' }}</td>
              <td>{{ p.grade_out_pct | number:'1.2-2' }}</td>
              <td>{{ p.curve_length_m | number:'1.0-0' }}</td>
              <td>{{ pviComputedK(p) | number:'1.0-1' }}</td>
              <td>{{ p.curve_kind || '—' }}</td>
              <td>{{ p.t1_label || formatChainageFromMeters(p.t1_measure_m) }}</td>
              <td>{{ p.t2_label || formatChainageFromMeters(p.t2_measure_m) }}</td>
              <td><button type="button" class="btn-link" (click)="deletePvi(p.id); $event.stopPropagation()">Delete</button></td>
            </tr>
          </tbody>
        </table>
        <p class="hint" *ngIf="!verticalPvis.length">No PVIs yet — add one above or re-run the LRS demo seed.</p>

        <h3>Existing ground (EGL)</h3>
        <div class="alignment-form">
          <label>Chainage (km) <input type="number" step="0.001" [(ngModel)]="groundMeasureKm" /></label>
          <label>Elevation (m) <input type="number" step="0.01" [(ngModel)]="groundElevM" /></label>
          <label>Source
            <select [(ngModel)]="groundSource">
              <option value="survey">survey</option>
              <option value="dem">dem</option>
              <option value="import">import</option>
            </select>
          </label>
          <button type="button" class="btn secondary" (click)="addGroundSample()">Add sample</button>
        </div>
        <ul class="mini-list ground-list">
          <li *ngFor="let g of groundSamples">
            {{ formatChainageFromMeters(g.measure_m) }} · {{ g.elevation_m | number:'1.2-2' }} m
            <small>{{ g.source }}</small>
            <button type="button" class="btn-link" (click)="removeGroundSample(g)">Remove</button>
          </li>
        </ul>
      </section>

      <section *ngIf="selectedRoute && activePanel === 'field'" class="field-block">
        <h2>Field / mobile</h2>
        <p class="hint">GPS proximity search and lateral offset geometry.</p>
        <button type="button" class="btn primary" (click)="captureDeviceGps()" [disabled]="gpsCapturing">
          {{ gpsCapturing ? 'Locating…' : 'Use my GPS location' }}
        </button>
        <p class="hint" *ngIf="gpsLng != null && gpsLat != null">GPS: {{ gpsLng }}, {{ gpsLat }}</p>
        <label>Search radius (m) <input type="number" [(ngModel)]="fieldRadiusM" /></label>
        <button type="button" class="btn primary" (click)="runAssetsNearGps()">What's near my GPS?</button>
        <button type="button" class="btn secondary" (click)="previewOffsetGeometry()">Preview offset on map</button>

        <h3>Offline queue</h3>
        <p class="hint">Assets saved while offline are kept locally and synced when the network returns.</p>
        <p>
          <strong>{{ pendingOfflineCount }}</strong> pending
          <span *ngIf="offlineSyncing"> · syncing…</span>
        </p>
        <button type="button" class="btn secondary" (click)="syncOfflineQueue()" [disabled]="!pendingOfflineCount || offlineSyncing">
          Sync now
        </button>
        <button type="button" class="btn secondary" (click)="clearOfflineQueue()" [disabled]="!pendingOfflineCount">
          Discard queue
        </button>
        <ul class="mini-list" *ngIf="nearbyItems.length">
          <li *ngFor="let n of nearbyItems">
            <strong>{{ n['layer'] }}</strong> {{ n['type'] || n['utility_type'] }} · {{ nearbyDistanceM(n) | number:'0.0-0' }} m along route
          </li>
        </ul>
      </section>

      <section *ngIf="(assetEvents.length || assetSearchQuery) && activePanel === 'assets'" class="events-block">
        <h3>
          Assets on route ({{ filteredAssetEvents.length }}<ng-container *ngIf="assetSearchQuery.trim()"> of {{ assetEvents.length }}</ng-container>)
        </h3>
        <p class="hint" *ngIf="assetSearchQuery.trim() && !filteredAssetEvents.length">No highway assets match the search.</p>
        <ul class="event-list">
          <li
            *ngFor="let e of filteredAssetEvents"
            [attr.data-type]="e.event_type"
            class="event-list-item"
            [class.selected]="assetDetailOpen && selectedAssetId === e.id && assetDetailKind === 'highway'"
            (click)="openAssetFromList(e)"
          >
            <img class="etype-icon" [src]="assetIconPath(e.event_type)" [alt]="e.event_type" width="18" height="18" />
            <span class="etype-badge" [style.background]="assetColor(e.event_type)">{{ e.event_type }}</span>
            <span class="ch">
              {{ e.chainage_label }}
              <ng-container *ngIf="e.measure_to_m"> → {{ e.chainage_to_label || (e.measure_to_m / 1000 | number: '1.3-3') + ' km' }}</ng-container>
            </span>
            <span class="lbl">{{ e.label }}</span>
            <button type="button" class="btn-link" (click)="retireAssetEvent(e.id); $event.stopPropagation()">Retire</button>
          </li>
        </ul>
      </section>

      <section *ngIf="linkedDocuments.length" class="doc-attach">
        <h3>Documents on route ({{ linkedDocuments.length }})</h3>
        <ul class="mini-list">
          <li
            *ngFor="let d of linkedDocuments"
            class="doc-list-item"
            [class.selected]="d.id === documentId"
          >
            <div>
              <strong>{{ d.document_name }}</strong>
              <small>{{ formatLinkedDocumentChainage(d) }}</small>
            </div>
            <button type="button" class="btn-link" (click)="panToLinkedDocument(d)">Pan</button>
          </li>
        </ul>
      </section>

      <section *ngIf="documentId && selectedRoute" class="doc-attach">
        <button type="button" class="btn primary" (click)="attachDocumentChainage()">
          Tag document #{{ documentId }}
        </button>
      </section>

      <p class="status sidebar-status" *ngIf="integratedMode && statusMessage">{{ statusMessage }}</p>

      <details class="legend-disclosure" *ngIf="integratedMode">
        <summary>Legend</summary>
        <div class="map-legend map-legend-inline">
        <span class="swatch route"></span> Route
        <span class="swatch linear"></span> Linear
        <span class="swatch event"></span> Point
        <span class="swatch calib"></span> Calib
        <span class="swatch util"></span> Util
        <span class="legend-sep">Grade</span>
        <span class="swatch grade-ug"></span> UG
        <span class="swatch grade-og"></span> OG
        <span class="swatch grade-xo"></span> XO
        <span class="legend-sep">Status</span>
        <span class="swatch status-planned"></span> Planned/Construction
        <span class="swatch status-maint"></span> Maintenance
        <span class="swatch status-decomm"></span> Decommissioned
        <span class="swatch status-critical"></span> Critical
        <span class="type-swatch" *ngFor="let u of utilityTypes" [title]="u.label">
          <img [src]="u.iconPath" width="12" height="12" [alt]="u.label" />
        </span>
        </div>
      </details>
    </aside>

    <div class="lrs-map-wrap" *ngIf="!integratedMode">
      <div #mapHost class="lrs-map"></div>
      <ng-container *ngTemplateOutlet="assetDetailAndLegend"></ng-container>
    </div>
  </div>

  <div class="lrs-map-wrap integrated-overlays" *ngIf="integratedMode">
    <ng-container *ngTemplateOutlet="assetDetailPanel"></ng-container>
  </div>
</div>

<ng-template #assetDetailPanel>
      <aside class="asset-detail-panel" *ngIf="assetDetailOpen">
        <header class="asset-detail-header" *ngIf="clusterPickCandidates">
          <h3>Select asset</h3>
          <button type="button" class="btn-close" (click)="closeAssetDetail()" aria-label="Close">×</button>
        </header>

        <div *ngIf="clusterPickCandidates" class="cluster-pick-list">
          <p class="hint">Multiple assets at this location — pick one:</p>
          <button
            type="button"
            class="cluster-pick-btn"
            *ngFor="let c of clusterPickCandidates"
            (click)="pickClusterCandidate(c)"
          >
            <img [src]="assetIconPath(c.type)" width="20" height="20" [alt]="c.type" />
            <span>{{ c.label }}</span>
            <small>{{ c.type }}</small>
          </button>
        </div>

        <app-lrs-asset-details
          *ngIf="!clusterPickCandidates && selectedAssetId"
          [kind]="assetDetailKind === 'utility' ? 'utility' : 'event'"
          [assetId]="selectedAssetId"
          (closed)="closeAssetDetail()"
          (saved)="onAssetDetailSaved()"
          (retired)="onAssetDetailRetired()"
          (openLinked)="openLinkedAsset($event)"
        ></app-lrs-asset-details>
      </aside>
</ng-template>

<ng-template #assetDetailAndLegend>
      <ng-container *ngTemplateOutlet="assetDetailPanel"></ng-container>

      <div class="map-legend">
        <span class="swatch route"></span> Route
        <span class="swatch linear"></span> Linear assets
        <span class="swatch event"></span> Point assets
        <span class="swatch calib"></span> Calibration
        <span class="swatch segprev"></span> Segment preview
        <span class="swatch pavement"></span> PCI
        <span class="swatch maint"></span> Maintenance
        <span class="swatch util"></span> Utilities
        <span class="legend-sep">Grade</span>
        <span class="swatch grade-ug"></span> Underground
        <span class="swatch grade-og"></span> Overground
        <span class="swatch grade-xo"></span> Crossover / underpass / overpass
        <span class="legend-sep">Status</span>
        <span class="swatch status-planned"></span> Planned / construction
        <span class="swatch status-maint"></span> Maintenance
        <span class="swatch status-decomm"></span> Decommissioned
        <span class="swatch status-critical"></span> Critical / damaged
        <span class="legend-sep">Types</span>
        <span class="type-swatch" *ngFor="let u of utilityTypes" [title]="u.label">
          <img [src]="u.iconPath" width="12" height="12" [alt]="u.label" />
        </span>
        <span class="type-swatch" *ngFor="let t of crossingTypes" [title]="t.label">
          <img [src]="t.iconPath" width="12" height="12" [alt]="t.label" />
        </span>
        <span class="swatch marker"></span> Locate
        <span class="swatch clash"></span> Clash
        <span class="swatch offsetline"></span> Offset lane
      </div>
</ng-template>
